<script lang="ts">
    import { fly } from "svelte/transition";
    import { getNavigatorType, isAndroid as isAndroidFct, NavigatorType } from "../../WebRtc/DeviceUtils";
    import { LL } from "../../../i18n/i18n-svelte";
    import { mediaPermissionDeniedStore } from "../../Stores/MediaStatusStore";
    import { popupStore } from "../../Stores/PopupStore";
    import { IconInfoCircle } from "@wa-icons";

    let isAndroid = isAndroidFct();
    let isFirefox = getNavigatorType() === NavigatorType.firefox;
    let isChrome = getNavigatorType() === NavigatorType.chrome;
    let showDetails = $state(false);

    let cameraDenied = $derived($mediaPermissionDeniedStore.camera);
    let microphoneDenied = $derived($mediaPermissionDeniedStore.microphone);
    let cameraAndMicrophoneDenied = $derived(cameraDenied && microphoneDenied);

    function allow() {
        showDetails = !showDetails;
    }

    function close() {
        popupStore.removePopup("cameraAccessDenied");
    }
</script>

<form
    class="helpCameraSettings pointer-events-auto z-[600] flex w-full flex-col self-center overflow-hidden rounded-[var(--nutrivera-shell-radius)] border border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-bg)] text-center text-sm text-[var(--nutrivera-shell-text)] shadow-[0_6px_8px_rgb(7_17_28/28%)] md:w-2/3 md:text-base xl:w-[380px]"
    onsubmit={(event) => {
        event.preventDefault();
        close();
    }}
    transition:fly={{ y: -50, duration: 500 }}
>
    <section class="mb-0">
        <div
            class="mb-0 border border-solid border-transparent border-b-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-raised)] px-4 py-3 text-lg font-semibold"
        >
            {#if cameraAndMicrophoneDenied}
                {$LL.camera.help.title()}
            {:else if cameraDenied}
                {$LL.camera.help.cameraTitle()}
            {:else}
                {$LL.camera.help.microphoneTitle()}
            {/if}
        </div>
        {#if showDetails}
            <div class="px-4 mt-4">
                <p class="help-text !text-[var(--nutrivera-shell-danger)]">
                    <IconInfoCircle class="mr-2 mb-1 min-w-6" font-size="18" />
                    {#if cameraAndMicrophoneDenied}
                        {$LL.camera.help.cameraMicrophonePermissionDenied()}
                    {:else if cameraDenied}
                        {$LL.camera.help.cameraPermissionDenied()}
                    {:else}
                        {$LL.camera.help.microphonePermissionDenied()}
                    {/if}
                </p>
            </div>
            <div class="p-4 text-sm leading-4 text-[var(--nutrivera-shell-muted)] italic">
                {#if cameraAndMicrophoneDenied}
                    {$LL.camera.help.content()}
                {:else if cameraDenied}
                    {$LL.camera.help.cameraContent()}
                {:else}
                    {$LL.camera.help.microphoneContent()}
                {/if}
            </div>
            {#if isFirefox}
                <p class="err">
                    {$LL.camera.help.firefoxContent()}
                </p>
            {/if}
            <div class="h-72 overflow-hidden opacity-80 saturate-50">
                {#if isFirefox}
                    <img
                        draggable="false"
                        src={$LL.camera.help.screen.firefox()}
                        alt="help media setup"
                        class="w-full m-auto"
                    />
                {:else if isChrome && !isAndroid}
                    <img
                        draggable="false"
                        src={$LL.camera.help.screen.chrome()}
                        alt="help media setup"
                        class="w-full m-auto"
                    />
                {/if}
            </div>
        {/if}
    </section>
    <section
        class="row flex justify-center border-t border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-raised)] p-4"
    >
        <button
            class="btn btn-sm mr-2 w-full justify-center rounded-[9px] border border-solid border-[var(--nutrivera-shell-accent)] bg-[var(--nutrivera-shell-accent)] text-[var(--nutrivera-shell-accent-ink)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--nutrivera-shell-accent)]"
            onclick={(event) => {
                event.preventDefault();
                allow();
            }}
        >
            {#if cameraAndMicrophoneDenied}
                {$LL.camera.help.allowCameraMicrophone()}
            {:else if cameraDenied}
                {$LL.camera.help.allow()}
            {:else}
                {$LL.camera.help.allowMicrophone()}
            {/if}
        </button>
        <button
            type="submit"
            class="btn btn-sm w-full justify-center rounded-[9px] border border-solid border-[var(--nutrivera-shell-danger)] bg-[var(--nutrivera-shell-danger)] text-[var(--nutrivera-shell-text)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--nutrivera-shell-accent)]"
            onclick={(event) => {
                event.preventDefault();
                close();
            }}
        >
            {#if cameraAndMicrophoneDenied}
                {$LL.camera.help.continueCameraMicrophone()}
            {:else if cameraDenied}
                {$LL.camera.help.continue()}
            {:else}
                {$LL.camera.help.continueWithoutMicrophone()}
            {/if}
        </button>
    </section>
</form>
